import { ApplianceModel, CutoutModel } from '../models';

export type CutoutId = CutoutModel['productId'];
export type ApplianceId = ApplianceModel['productId'];

export enum ApplianceQtyType {
  onShape = 'onShape',
  onCard = 'onCard',
}

export type CustomCutoutRecord = Record<
  CutoutId,
  Record<ApplianceQtyType, number>
>;
export type ApplianceCutoutRecord = Record<
  CutoutId,
  Record<ApplianceId, number>
>;

export interface SelectedCustomCutouts {
  selected: CustomCutoutRecord;
  previousSelected?: SelectedCustomCutouts | undefined;
}

export interface SelectedApplianceCutouts {
  selected: ApplianceCutoutRecord;
  previousSelected?: SelectedApplianceCutouts | undefined;
}

export type ApplianceRecord = Record<
  ApplianceId,
  Record<ApplianceQtyType, number>
>;

export type SelectedSinksAmount = {
  id: ApplianceId;
  hasChipMinimizer?: boolean;
}[];

export type SelectedApplianceProductType =
  | 'selectedCooktopApplianceProduct'
  | 'selectedRangeApplianceProduct';

export interface SelectedAppliances {
  selected: ApplianceRecord;
  previousSelected?: SelectedAppliances | undefined;
}

export type CurrentSelectedAppliances = Record<
  SelectedApplianceProductType,
  SelectedAppliances
>;

/** Persisted subset of SelectedAppliances — excludes transient `previousSelected` (undo state) so it is never serialized into a saved estimate (enforced by `buildApplianceSelectionsForEstimate`). */
export type PersistedSelectedAppliances = Record<
  SelectedApplianceProductType,
  Omit<SelectedAppliances, 'previousSelected'>
>;
